module.exports = __webpack_public_path__ + "img/EN.0e177de8.svg";